"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartEvent = void 0;
const Constants_1 = require("../Constants");
const EventBase_1 = require("./EventBase");
/**
 * Describes a BPMN StartEvent.
 */
class StartEvent extends EventBase_1.Event {
    get bpmnType() {
        return Constants_1.BpmnType.startEvent;
    }
    get eventType() {
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        const eventIsTimerEvent = this.timerEventDefinition !== undefined;
        if (eventIsTimerEvent) {
            return Constants_1.EventType.timerEvent;
        }
        return undefined;
    }
}
exports.StartEvent = StartEvent;
//# sourceMappingURL=StartEvent.js.map